import moment from "moment-timezone";

import { initLanguageHandling, getUserLocale } from "./userFunctions";

let bootstrappedInstance: { moment: typeof moment; locale: string } = null;
export const bootstrapApplication = () => {
    if (!bootstrappedInstance) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        initLanguageHandling();

        const locale = getUserLocale();
        const setLocale = moment.locale(locale);

        bootstrappedInstance = {
            locale: setLocale,
            moment,
        };
    }
    return bootstrappedInstance;
};
